<template>
    <ul class="gift-list">
        <li v-for="giftItem in giftRecord" :key="giftItem.id" class="gift-item">
            <img :src="giftItem.cover" class="gift-item-img"/>
            <div class="gift-item-foot">
                <span class="gift-label">{{giftItem.name}}</span>
                <span class="gift-num">x{{ giftItem.num }}</span>
            </div>
        </li>
    </ul>
  </template>
  
  <script>
  export default {
    name: "UserInfo",
    props: {
      giftRecord: {
        type: Array,
        default: () => [],
      },
    },
  }
  </script>
  
  <style scoped>
  .gift-list {
      display: flex;
      gap: 24px;
      width: 600px;
      padding: 0;
      margin: 0;
      margin-bottom: 24px;
      overflow: auto;
  }
  .gift-list::-webkit-scrollbar {
      display: none;
  }
  .gift-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      padding: 20px 20px 8px;
      background: #fff3d3;
      border-radius: 23px;
      box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset; 
  }
  .gift-item-img {
      width: 106px;
      height: 106px;
  }
  .gift-item-foot {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 12px;
  }
  .gift-label {
      font-size: 20px;
      font-weight: bold;
      color: #6F6C68;
  }
  .gift-num {
      margin-left: 8px;
      font-size: 24px;
      font-weight: bold;
      color: #8BB91C;
  }
  </style>